<mat-dialog-content class="dialog_content">
  <ngx-extended-pdf-viewer height="100vh" rotation="0.0" [src]="data.pdf"></ngx-extended-pdf-viewer>
  <div class="mt_20 f_center" id="dialogCloseBtn">
    <app-button size="sm" class="dialog_close"
                (btnClicked)="closeDialog()">
      {{'global.close' | translate}}
    </app-button>
  </div>
</mat-dialog-content>
